import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { DBService } from '../../db.service';
import { slide } from '../../animations';

@Component({
  selector: 'forum-form-modal',
  templateUrl: './forum-form-modal.component.html',
  styleUrls: ['./forum-form-modal.component.scss'],
  animations: [
    slide
  ]
})
export class ForumFormModalComponent implements OnInit {
  @Input()  selectedForum: any;
  @Output() onHideFormModal = new EventEmitter<boolean>();

  forum = {
    name: "",
    userLevels: []
  };

  membersAccess = false;
  managersAccess  = false;
  ownersAccess  = false;
  vendorsAccess = false;

  constructor(private dbService: DBService) { }

  ngOnInit() {
    if (this.selectedForum) {
      this.forum.name = this.selectedForum.name;

      let acl = this.selectedForum.userLevels;

      this.membersAccess = (acl[1] == true);
      this.ownersAccess =  (acl[2] == true);
      this.vendorsAccess = (acl[0] == true);
      this.managersAccess = (acl[3] == true);
    }
  }

  onHideModal() {
    this.onHideFormModal.emit(true);
  }

  submitForm() {

    this.forum.userLevels = [this.vendorsAccess, this.membersAccess, this.ownersAccess, this.managersAccess];

    if (this.selectedForum) {
      this.dbService.updateForum(this.selectedForum.$key, this.forum);
    } else {
      this.dbService.addForum(this.forum);
    }

    this.onHideModal();
  }

}



// WEBPACK FOOTER //
// ./src/app/forums/forum-form-modal/forum-form-modal.component.ts